import { Injectable, computed, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { User } from '@core/interfaces/interfaces';

const SESSION_STORAGE_KEY = 'user';

@Injectable({ providedIn: 'root' })
export class UserSessionService {
	private readonly userSignal = signal<User | null>(this.readFromStorage());

	readonly user = this.userSignal.asReadonly();
	readonly user$ = toObservable(this.userSignal);

	readonly userId = computed(() => this.userSignal()?.id ?? null);
	readonly farmId = computed(() => this.userSignal()?.farmId ?? null);
	readonly userName = computed(() => this.userSignal()?.name ?? null);
	readonly userType = computed(() => this.userSignal()?.type ?? null);
	readonly isLoggedIn = computed(() => this.userSignal() !== null);

	getCurrentUser(): User | null {
		return this.userSignal();
	}

	setUser(user: User): void {
		sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(user));
		this.userSignal.set(user);
	}

	clearUser(): void {
		sessionStorage.removeItem(SESSION_STORAGE_KEY);
		this.userSignal.set(null);
	}

	private readFromStorage(): User | null {
		try {
			const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
			return raw ? (JSON.parse(raw) as User) : null;
		} catch {
			return null;
		}
	}
}
